export default __webpack_public_path__ + "static/media/82-min.30137c5e.jpg";